import React from 'react';
import { SlideUpModal } from '../views/comparison_views/molecules/SlideUpModal';
import { ModifyDataPointModalContent } from './ModifyDataPointModalContent';
import { withMapUtils } from '../util/hocs/withMapUtils';

const ModifyDataPointModalComponent = ({
  open,
  onClose,
  data,
  onFormEdit,
  customFormEdit,
  openDataName = null,
  isGoogleApiLoaded,
  onGoogleMapLoad,
  onGoogleMapUnmount,
  placesService,
  googleMap,
  setFirstTimeBuyer,
  validationObject,
  onSubmitAddress,
}) => {
  return (
    <SlideUpModal
      open={open}
      onClose={onClose}
    >
      <ModifyDataPointModalContent
        open={open}
        onClose={onClose}
        setFirstTimeBuyer={setFirstTimeBuyer}
        data={data}
        openDataName={openDataName}
        isGoogleApiLoaded={isGoogleApiLoaded}
        onGoogleMapLoad={onGoogleMapLoad}
        onGoogleMapUnmount={onGoogleMapUnmount}
        placesService={placesService}
        customFormEdit={customFormEdit}
        googleMap={googleMap}
        onFormEdit={onFormEdit}
        validationObject={validationObject}
        onSubmitAddress={onSubmitAddress}
      />
    </SlideUpModal>
  );
};

export const ModifyDataPointModal = withMapUtils(ModifyDataPointModalComponent);
